import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const CalendlyContext = createContext(null);

export function CalendlyProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState('https://calendly.com/YOUR_LINK/20min');

  const open = useCallback((link) => {
    setUrl(link || 'https://calendly.com/YOUR_LINK/20min');
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, open, close, url }),
    [isOpen, open, close, url]
  );

  return <CalendlyContext.Provider value={value}>{children}</CalendlyContext.Provider>;
}

export default function useCalendly() {
  const ctx = useContext(CalendlyContext);
  if (!ctx) {
    throw new Error('useCalendly must be used within a CalendlyProvider');
  }
  return ctx;
}
